import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {ValueOrderData} from "@reva/shared/value-order";

interface ValueOrdersSliceState {
    /** all associated value orders (already ordered, with the most relevant order in the beginning) */
    orders: ValueOrderData[];
    /** the associated order of type "Reva" (should exist, except for some legacy valuations) */
    revaOrder: ValueOrderData | null;
}

const initialState: ValueOrdersSliceState = {
    orders: [],
    revaOrder: null,
};

export const valueOrdersSlice = createSlice({
    name: "valueOrders",
    initialState,
    reducers: {
        resetValueOrders: (state) => {
            state.orders = initialState.orders;
            state.revaOrder = initialState.revaOrder;
        },
        setValueOrders: (state, action: PayloadAction<ValueOrderData[]>) => {
            const orders = Array.isArray(action.payload) ? action.payload : [];
            state.orders = orders;
            state.revaOrder = orders.find((o) => o.orderType === "Reva") || null;
        },
    },
    selectors: {
        selectValueOrders: (state) => state.orders,
        selectRevaOrder: (state) => state.revaOrder,
        selectHasValueOrders: (state) => !!state.orders.length,
    },
});

export const {resetValueOrders, setValueOrders} = valueOrdersSlice.actions;

export const {selectValueOrders, selectRevaOrder, selectHasValueOrders} = valueOrdersSlice.selectors;

export default valueOrdersSlice.reducer;
